import TextInput from '@/components/form/TextInput';
import { SearchIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';

const SearchBox = connectSearchBox(
  ({ refine, currentRefinement, className, onFocus }) => (
    <div className={clsx(className, 'relative')}>
      <TextInput
        name="search"
        placeholder="Search"
        innerClassName="py-1 pr-0"
        endPiece={<SearchIcon className="h-5 w-5 -mr-2" />}
        formik={
          {
            getFieldProps: () => ({
              onChange: (e) => refine(e.target.value),
              value: currentRefinement,
              onFocus,
            }),
            touched: { search: true },
            errors: {},
          } as any
        }
      />
    </div>
  )
);

export default SearchBox;
